import {initialState} from './states';
export const company = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SIGNALS_LIST': {
            return {
                ...state,
                signalsList: action.payload,
            };
        }
        case 'SET_CORRECT_ID': {
            return {
                ...state,
                correctId: action.payload,
            };
        }
        case 'SET_COMPANY_SHARE_PRICE': {
            return {
                ...state,
                companySharePrice: action.payload,
            };
        }
        case 'SET_COMPANY_LIST': {
            return {
                ...state,
                companyList: action.payload,
            };
        }
        case 'SET_FINANCIAL_DATA': {
            return {
                ...state,
                financialData: action.payload,
            };
        }
        case 'SET_CRITICAL_FACTORS': {
            return {
                ...state,
                criticalFactorsList: action.payload,
            };
        }
        case 'SET_FILTERED_CRITICAL_FACTORS': {
            return {
                ...state,
                filteredCriticalFactors: action.payload,
            };
        }
        case 'SET_ACTIVE_RIC': {
            return {
                ...state,
                activeRic: action.payload,
            };
        }
        case 'SET_ACTIVE_RIC_VALUE': {
            return {
                ...state,
                activeRicValue: action.payload,
            };
        }

        case 'SET_STOCK_CONSENSUS': {
            return {
                ...state,
                stockConsensusGraphData: action.payload,
            };
        }
        case 'SET_SHARE_RATIO': {
            return {
                ...state,
                shareRatioGraphData: action.payload,
            };
        }
        case 'SET_360_DATA': {
            return {
                ...state,
                degreeView: action.payload,
            };
        }
        case 'SET_EPS_DATA': {
            return {
                ...state,
                epsData: action.payload,
            };
        }
        case 'SET_SPECIFIC_COMPANY_SIGNAL': {
            return {
                ...state,
                companySpecificSignal: action.payload,
            };
        }
        case 'SET_IMPACT_DATA': {
            return {
                ...state,
                impactData: action.payload,
            };
        }

        case 'SET_NETWORK_DATA': {
            return {
                ...state,
                networkGraphData: action.payload,
            };
        }

        case 'SET_SIGNAL_MAP': {
            return {
                ...state,
                signalMap: action.payload,
            };
        }

        case 'RESET_STOCK_DATA': {
            return {
                ...state,
                stockConsensusGraphData: [],
            };
        }
        case 'RESET_SHARE_RATIO_DATA': {
            return {
                ...state,
                shareRatioGraphData: {},
            };
        }
        case 'RESET_FINANCIAL_DATA': {
            return {
                ...state,
                financialData: [],
            };
        }
        case 'RESET_EPS_DATA': {
            return {
                ...state,
                epsData: {},
            };
        }
        case 'SET_COMPANY_ANALYST_DATA': {
            return {
                ...state,
                companyAnalystData: action.payload,
            };
        }
        case 'SET_CHAT_BOT':
            return {
                ...state,
                showChatBot: !state.showChatBot,
            };
        case 'SET_CHAT_NOTIFICATION':
            return {
                ...state,
                showNotifications: action.payload,
            };
        case 'CHECK_ANALYST_STATUS':
            return {
                ...state,
                analystStatus: action.payload,
            };
        case 'LOGOUT': {
            return {...initialState};
        }
        default:
            return state;
    }
};
